import { useState } from 'react'
import dynamic from 'next/dynamic'

import { useTranslation } from '@mc/i18n'
import { IconPlayDefault, Button } from '@mc/design-system'
import { TRACK_CONTENT_TYPES } from '@mc/track-event'

import CTA from 'components/CTA'

import { ACTIONS, trackAction, TrackProps } from '../events'

const VideoModal = dynamic(() => import('components/VideoModal'), {
  ssr: false,
})

export interface TrailerProps {
  brightcoveVideoId?: string | null
  mediaUuid?: string | null
  instructorName?: string | null
  headline?: string | null
  id?: string | number | null
  slug?: string | null
  title?: string | null
  instructorAvatar?: string | null
}

const TrailerAction = ({
  trackProps,
  trailer,
}: {
  trackProps: TrackProps
  trailer?: TrailerProps
}) => {
  const [isOpen, setIsModalOpen] = useState(false)
  const { t } = useTranslation('@mc/next')

  if (!trailer?.brightcoveVideoId && !trailer?.mediaUuid) return <></>

  const handleClick = () => {
    trackAction(trackProps, ACTIONS.TRAILER)
    setIsModalOpen(true)
  }

  const handleModalClose = () => setIsModalOpen(false)

  const videoModalProps = {
    show: isOpen,
    onCloseModal: handleModalClose,
    videoId: trailer.brightcoveVideoId,
    mediaUuid: trailer.mediaUuid || '',
    author: trailer.instructorName,
    tagline: trailer.headline,
    contentId: `${trailer.id}_${
      trailer.brightcoveVideoId ?? trailer.mediaUuid
    }`,
    contentTitle: trailer.title || '',
    contentType: TRACK_CONTENT_TYPES.COURSE_TRAILER,
    courseId: trailer.id || 0,
    instructorAvatar: trailer.instructorAvatar,
    buttonGroup: (
      <CTA
        trackProps={{
          category: 'need-to-know',
          class: trailer.slug,
          content_type: 'product',
          location: 'hero_trailer_modal',
          page_category: 'personalization',
        }}
      />
    ),
  }

  return (
    <>
      <Button
        kind='link'
        className='d-inline-flex flex-column'
        onClick={handleClick}
      >
        <IconPlayDefault className='mc-icon--4 mc-mb-4' size='lg' />
        {t('course.trailer')}
      </Button>

      {isOpen && <VideoModal {...videoModalProps} />}
    </>
  )
}

export default TrailerAction
